export default function Tags({ tags }) {
  return tags?.length ?
    tags.map((tag, index) => <span key={index}>#{tag}{index == tags.length - 1 ? '' : ','} </span>)
    : null
}